import BasicResource from '@/api/resource';

class Resource extends BasicResource {

    constructor () {
        super('dicts');
    }

    clicktagParams () {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/dict/clicktag-params',
            params: { limit: -1 },
        });
    }

    postbackParams () {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/dict/postback-params',
            params: { limit: -1 },
        });
    }

    approvalStatusesList () {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/dict/approval-statuses',
            params: { limit: -1 },
        });
    }

    clicktagsList () {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/dict/clicktags',
            params: { limit: -1 },
        });
    }

    eventTypes () {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/dict/event-types',
        });
    }

    currencies (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/dict/currencies',
            params: { ...params, limit: -1 },
        });
    }

    countries (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/dict/countries',
            params: { limit: -1, ...params },
        });
    }

    trackingLinks (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/dict/tracking-links',
            params: { limit: -1, ...params },
        });
    }

    approvalsOffers (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/dict/approvals-offers',
            params: { limit: -1, ...params },
        });
    }

    // TODO: create a new endpoint in publisher namespace
    categories () {
        return this.client.request({
            method: 'get',
            path: '/public/v1/dict/categories',
            params: { limit: -1 },
        });
    }

    offerTags (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/dict/offer-tags',
            params,
        });
    }

    offerTagsPublic (params) {
        return this.client.request({
            method: 'get',
            path: '/public/v1/dict/offer-tags',
            params,
        });
    }
}

export default new Resource;
